module.exports = __webpack_public_path__ + "img/2.e56613f8.jpg";